<script>
  export default {
    name: "TextIcon",
    props: {
      icon: { type: String, default: "" },
      styles: { type: Object, default: () => ({}) },
      label: { type: String, default: "" },
      variant: {
        validator: (v) => ["primary", "secondary", "danger", "success"].includes(v),
        default: "primary",
        type: String,
      },
    },
  };
</script>

<template>
  <div class="userNameTimeStamp" :class="`userNameTimeStamp--${variant}`" @click="$emit('click')">
    <div class="userNameTimeStamp__container">
      <iconic :name="icon" v-if="icon" :style="styles.icon" />
      <span class="userNameTimeStamp__label" :style="styles.label">{{ label }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .userNameTimeStamp {
    @include Flex(row, space-between);
    font-family: $newFont_medium;
    font-weight: 500;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    width: 100%;

    &__icon {
      font-size: 20px;
      margin-right: 12px;
    }

    &__container {
      @include Flex(row, flex-start);
      gap: 10px;
      width: 100%;
    }

    &--primary {
      .userNameTimeStamp {
        gap: 10px;
        &__icon {
          color: #313131;
          font-size: 16px;
        }

        &__label {
          font-family: $newFont_medium;
          font-size: 14px;
          color: #212121;
        }
      }
    }

    &--success {
      .userNameTimeStamp__icon {
        color: #21b329;
      }
    }
  }
</style>
